import { useCallback, ClipboardEvent } from "react";
import { Input } from "reactstrap";
import { addValidation } from "validation/ValidationWrapper";
import { Tooltip } from "./Tooltip";

export type InputFieldProps = {
  label?: string;
  id: string;
  name: string;
  value: string;
  disabled?: boolean;
  onChange: (v: string) => void;
  onBlur?: (v: string) => void;
  onFocus?: (v: string) => void;
  placeholder?: string;
  maxLength?: number;
  tooltipText?: string;
  stopPaste?: boolean;
  ariaDescribedBy?: string;
  className?: string;
  ariaInvalid?: boolean;
};

export const InputField = ({
  label,
  id,
  name,
  value,
  disabled,
  onChange,
  onFocus,
  onBlur,
  placeholder,
  maxLength,
  tooltipText,
  stopPaste = false,
  ariaDescribedBy,
  ariaInvalid,
  className,
}: InputFieldProps) => {
  const pasteHandler = useCallback(
    (e: ClipboardEvent<HTMLInputElement>) =>
      stopPaste ? e.preventDefault() : null,
    [stopPaste]
  );
  return (
    <>
      {(tooltipText || label) && (
        <label
          htmlFor={id}
          className={`inputField-header ${
            tooltipText && !label ? "inputField-header-end" : ""
          }`}
        >
          {label && <div className="inputField-label">{label}</div>}
          {tooltipText && <Tooltip id={`${id}-tooltip`} text={tooltipText} />}
        </label>
      )}
      <Input
        id={id}
        name={name}
        value={value ?? ""}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onFocus={(e) => onFocus?.(e.target.value)}
        onBlur={(e) => onBlur?.(e.target.value)}
        className={className || "inputField"}
        placeholder={placeholder}
        maxLength={maxLength}
        onPaste={pasteHandler}
        aria-describedby={ariaDescribedBy}
        invalid={ariaInvalid}
      />
    </>
  );
};

export const ValidInputField = addValidation<InputFieldProps, string>(
  (p) => p.value
)(InputField);
